import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { IKpiRepository } from '@/coreInfrastructureModule/interfaces/IKpiRepository';
import { KpiFactory } from '../domains/factories/KpiFactory';
import { Kpi } from '../domains/entities/Kpi';
import { DashboardService } from '../domains/services/DashboardService';
import { DimensionTypes, MetricType, MetricTypes } from '../domains/entities/Dashboard';

/**
 * Kpi情報を取得する
 */
export class GetKpiUseCase {
  private repository: IKpiRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IKpiRepository) {
    this.repository = repository;
  }

  /**
   * 指定条件でKPIを取得し、ドメインモデルへ変換する
   * @param metricType - 分析種別
   * @param dimensionTypesList - 切り口種別の配列
   * @returns KPI配列の取得結果
   */
  public async execute(metricType: MetricType, dimensionTypesList: string[]): Promise<INetworkResult<Kpi[], IError>> {
    const convertMetricTypes = metricType.replace(/([a-z0-9])([A-Z])/g, '$1_$2').toUpperCase();
    const dimensionTypes = dimensionTypesList.join(',');
    const networkResult = await this.repository.get(convertMetricTypes, dimensionTypes);
    switch (networkResult.status.type) {
      case 'success': {
        const result = networkResult.status.data.result;
        return {
          status: {
            type: 'success',
            data: (result.kpis ?? []).map((kpi) => {
              return KpiFactory.create({
                metricType: DashboardService.isMetricType(result.metricType) ? result.metricType : MetricTypes.UNKNOWN,
                kpiValue: Number(kpi.kpiValue),
                dimensions: kpi.dimensions?.map((d) => {
                  return {
                    dimensionType: DashboardService.isDimensionType(d.dimensionType) ? d.dimensionType : DimensionTypes.UNKNOWN,
                    dimensionValue: d.dimensionValue,
                  };
                }),
              });
            }),
          },
        };
      }
      case 'error':
        return { status: { type: 'error', error: networkResult.status.error } };
    }
  }
}
